import { useState, useContext, useEffect, useMemo } from 'react'

import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import logoTextColourSource from '/components/editor/logo-text-colour-source'

const Logo = () => {

  const { passType, model, template, instanceData, scannerInstanceData } = useContext(PassContext)

  // We need to set a size for the text box in order to 
  // be able to truncate it. But we do not know how much
  // space we have for text until we [optionally] load the logo image

  const [textWidth, setTextWidth] = useState(200)
  const [imageWidth, setImageWidth] = useState(50)
  const [imageSrc, setImageSrc] = useState(null)

  const logoPath = "meta.images.logo"
  const logoSrcUrl = dataSelector({ template, instanceData, scannerInstanceData, path: logoPath })

  const titlePath = "meta.title"
  const titleValue = dataSelector({ template, instanceData, scannerInstanceData, path: titlePath })

  const maxLogoWidthBeforeHideText = 200 //TODO - check where the [practical] cut-off is.

  const imageLoaded = e => {
    const img = e.target
    const displayedImageWidth = (50 / img.height) * img.width
    setImageWidth(displayedImageWidth)
    setTextWidth(250 - displayedImageWidth)
  }

  const titleColor = useMemo(() => logoTextColor({ passType, model, template, instanceData, scannerInstanceData }),[model])

  useEffect(() => {
    if (!logoSrcUrl) return
    const img = new Image()
    img.crossOrigin = "anonymous"          // important for canvas/color picking
    img.onload = () => {
      setImageSrc(logoSrcUrl)
    }
    img.onerror = () => setImageSrc(null)
    img.src = logoSrcUrl                   // set after crossOrigin
  }, [logoSrcUrl])

  return (
    <div className="logo flex flex-row w-full justify-between items-center" style={{ width: 200 }}>
      <PopupEditor title="Logo Image" path="meta.images.logo">
        <div className="image" style={{ position: "relative" }}>
          <div style={{ position: "absolute", height: 50, width: imageWidth }} className="editable" />
          <img src={imageSrc} style={{ width: imageWidth }} onLoad={e => imageLoaded(e)} crossOrigin="anonymous" />
        </div>
      </PopupEditor>

      {(imageWidth < maxLogoWidthBeforeHideText) &&
        <PopupEditor title="Title Text" path="meta.title" colors={{ title: titleColor.path }}>
          <div className="text editable" style={{ width: textWidth, color: titleColor.color }}>
            {titleValue}
          </div>
        </PopupEditor>
      }
    </div>
  )
}

export default Logo


const logoTextColor = ({ passType, model, template, instanceData, scannerInstanceData }) => {

  switch (passType) {
    case "generic": // confirmed
    case "coupon": // confirmed
    case "boardingPass": // Confirmed
    case "storeCard": {
      const colourSource = logoTextColourSource(model)
      return { path: "model." + colourSource, color: model[colourSource] }
    }

    case "eventTicket":
      const bgImage = dataSelector({ template, instanceData, scannerInstanceData, path: "meta.images.background" })

      if (bgImage)
        // All pass types other than event with bg images, use label colour when image is dark.
        return { path: "model.labelColor", color: model.labelColor } // Undocumented, but event tickets with background image use label rather than foreground colour
      else {
        const colourSource = logoTextColourSource(model)
        return { path: "model." + colourSource, color: model[colourSource] }
      }
  }
}

